import useWindowDimensions from 'hooks/useWindowDimensions';
import { TWhatsNewNotification } from 'lendingApi/whatsNew';
import Markdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';
import remarkGfm from 'remark-gfm';
import { BREAK_S } from 'utils/breakpoints';
import { ContentDetails } from '../ContentDetails/ContentDetails';
import styles from './MainItem.module.css';

type TProps = {
  data: TWhatsNewNotification;
};
export const MainItem = ({ data }: TProps) => {
  const { width } = useWindowDimensions();

  return (
    <div id={`content-${data.id}`} className={styles.mainItem}>
      {width <= BREAK_S && (
        <div className={styles.details}>
          <ContentDetails data={data} />
        </div>
      )}
      <div className={styles.content}>
        <Markdown remarkPlugins={[remarkGfm]} rehypePlugins={[rehypeRaw]}>
          {data.text}
        </Markdown>
      </div>
    </div>
  );
};
